import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading

  useEffect(() => {
    const token = localStorage.getItem("pf_token");
    if (!token) {
      setUser(null);
      return;
    }
    api
      .get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => {
        localStorage.removeItem("pf_token");
        setUser(null);
      });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("pf_token", data.token);
    setUser({ id: data.id, email: data.email, name: data.name, role: data.role });
    return data;
  };

  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    localStorage.setItem("pf_token", data.token);
    setUser({ id: data.id, email: data.email, name: data.name, role: data.role });
    return data;
  };

  const verifyEmail = async (email) => {
    const { data } = await api.post("/auth/verify-email", { email });
    return data;
  };

  const resetPassword = async (email, newPassword) => {
    const { data } = await api.post("/auth/reset-password", { email, new_password: newPassword });
    return data;
  };

  const setSession = (u) => setUser(u);

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      /* ignore */
    }
    localStorage.removeItem("pf_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, register, verifyEmail, resetPassword, setSession, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
